import { get } from 'svelte/store';
import { format } from 'svelte-i18n';
import {
	bluTrvNewSchedulePositionSupport,
	bluTrvNewWebhookSupport,
} from '../../webhooks/supported/webhook_list_supported_helpers';
//Types
import type { ActionJob, LocalControlOptions } from 'src/types/requests/schedules/schedules_g2';
import type { Device } from 'src/types/Device';

export const getBluTRVLocalActions = (
	action: ActionJob,
	device: Device,
	scheduleAction: boolean,
): LocalControlOptions[] => {
	const $format = get(format);
	const trvID = device.channel - 2000;
	const localControlOptions: LocalControlOptions[] = [
		{
			title: $format('label_target_temperature', {
				default: 'Target temperature',
			}),
			value: 'blutrv.target',
			attr: {
				target_C: true,
			},
			params: {
				id: trvID,
				method: 'Trv.SetTarget',
				target_C:
					action.params?.target_C != null
						? action.params.target_C
						: bluTrvDefaultValue('target'),
			},
		},
	];
	const newWebhookSupport = !scheduleAction && bluTrvNewWebhookSupport(device.id);
	const newScheduleSupport = bluTrvNewSchedulePositionSupport(device.id);
	if (newWebhookSupport || newScheduleSupport) {
		if (newWebhookSupport) {
			localControlOptions.push({
				title: $format('sub_settings_title_boost', {
					default: 'Boost',
				}),
				value: 'blutrv.boost',
				attr: {
					duration: true,
				},
				params: {
					id: trvID,
					method: 'Trv.SetBoost',
					duration:
						action.params?.duration != null
							? action.params.duration
							: bluTrvDefaultValue('boost'),
				},
			});
		}
		localControlOptions.push({
			title: $format('collapse_title_chart_valve_position', {
				default: 'Valve position',
			}),
			value: 'blutrv.position',
			attr: {
				pos: true,
			},
			params: {
				id: trvID,
				method: 'Trv.SetPosition',
				pos: action.params?.pos != null ? action.params.pos : bluTrvDefaultValue('position'),
			},
		});
	}
	return localControlOptions;
};

export const getTRVLocalActions = (action: ActionJob): LocalControlOptions[] => {
	const $format = get(format);
	const localControlOptions: LocalControlOptions[] = [
		{
			title: $format('label_target_temperature', {
				default: 'Target temperature',
			}),
			value: 'trv.target',
			attr: {
				target_C: true,
			},
			params: {
				target_C:
					action.params?.target_C != null
						? action.params.target_C
						: bluTrvDefaultValue('target'),
			},
		},
		{
			title: $format('sub_settings_title_boost', {
				default: 'Boost',
			}),
			value: 'trv.boost',
			attr: {
				duration: true,
			},
			params: {
				duration:
					action.params?.duration != null
						? action.params.duration
						: bluTrvDefaultValue('boost'),
			},
		},
		{
			title: $format('collapse_title_chart_valve_position', {
				default: 'Valve position',
			}),
			value: 'trv.position',
			attr: {
				pos: true,
			},
			params: {
				pos: action.params?.pos != null ? action.params.pos : bluTrvDefaultValue('position'),
			},
		},
		{
			title: $format('label_external_temperature_correction', {
				default: 'External temperature correction',
			}),
			value: 'trv.ext_t',
			attr: {
				ext_C: true,
			},
			params: {
				ext_C: action.params?.ext_C != null ? action.params.ext_C : bluTrvDefaultValue('ext_t'),
			},
		},
	];
	return localControlOptions;
};

export const bluTrvDefaultValue = (method: string): number => {
	switch (method) {
		case 'target':
			return 18;
		case 'boost':
			return 30;
		case 'position':
			return 50;
	}
	return 0;
};
